// extracted by mini-css-extract-plugin
export var checkmark = "filter-checkbox-module--checkmark--67a6e";
export var input = "filter-checkbox-module--input--4d5fc";
export var label = "filter-checkbox-module--label--9cc7d";
export var text = "filter-checkbox-module--text--fa0d5";